import { render, staticRenderFns } from "./PatientSpectateTelehealthAttendance.vue?vue&type=template&id=0d483b31&lang=html&"
import script from "./PatientSpectateTelehealthAttendance.vue?vue&type=script&lang=js&"
export * from "./PatientSpectateTelehealthAttendance.vue?vue&type=script&lang=js&"
import style0 from "./PatientSpectateTelehealthAttendance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports